// Steps 2 and 3: your connection (role), then pick a topic.
import { logger } from '../lib/log.js';
import { $, el, plural } from './dom.js';

const log = logger('record');

const KIND_DESC = {
  lightning: 'Quick questions, short answers',
  addon: 'Extra questions for you',
  open: 'Tell a story we did not ask about',
};

export function createTopicScreens(app) {
  const { root, state, data } = app;
  const roleSec = $('[data-step="role"]', root);
  const topicSec = $('[data-step="topic"]', root);
  const topicList = $('[data-topic-list]', topicSec);
  const topicIntro = $('[data-topic-intro]', topicSec);

  $('[data-role-list]', roleSec).addEventListener('click', (e) => {
    const b = e.target.closest('[data-role]');
    if (!b) return;
    const roleId = b.getAttribute('data-role');
    app.setRole(roleId);
    log.info('role_select', { role: roleId });
    app.go('topic');
  });

  topicList.addEventListener('click', (e) => {
    const b = e.target.closest('[data-topic]');
    if (!b) return;
    const topic = state.topics.find((t) => t.id === b.getAttribute('data-topic'));
    if (!topic) return;
    // Start at the first question not yet answered in this topic.
    const kept = new Set(state.clips.map((c) => c.promptId));
    const first = topic.prompts.findIndex((p) => !kept.has(p.id));
    app.openTopic(topic, first >= 0 && topic.kind !== 'open' ? first : 0);
    log.info('topic_select', { topicId: topic.id, role: state.draft.role });
    app.go('prompt', { direction: 'topic' });
  });

  app.on('to-role', () => app.go('role'));
  app.on('to-topics', () => {
    if (state.step === 'prompt') { app.requestLeavePrompt({ type: 'topics' }); return; }
    app.go('topic');
  });

  function renderTopics() {
    if (!state.topics.length) state.topics = data.topicsFor(state.draft.role || 'all');
    const role = data.roleById(state.draft.role);
    if (topicIntro) {
      topicIntro.textContent = role
        ? `Here are the topics for ${role.plural.charAt(0).toLowerCase()}${role.plural.slice(1)}, in the order we suggest. Start with any one you like.`
        : 'Here is every topic, in the order we suggest. Start with any one you like.';
    }
    const keptIds = new Set(state.clips.map((c) => c.promptId));
    topicList.replaceChildren(...state.topics.map((t) => {
      const answered = t.prompts.filter((p) => keptIds.has(p.id)).length;
      const openCount = t.kind === 'open' ? state.clips.filter((c) => c.promptId === t.prompts[0].id).length : 0;
      const metaParts = [];
      if (t.eraLabel) metaParts.push(t.eraLabel);
      if (KIND_DESC[t.kind]) metaParts.push(KIND_DESC[t.kind]);
      if (t.kind !== 'open') metaParts.push(plural(t.prompts.length, 'question', 'questions'));
      const doneCount = t.kind === 'open' ? openCount : answered;
      return el('li', {}, [
        el('button', { type: 'button', class: `rec-option${doneCount ? ' rec-option--done' : ''}`, 'data-topic': t.id }, [
          t.suggested ? el('span', { class: 'tag rec-option__tag' }, 'Start here') : null,
          el('span', { class: 'rec-option__title' }, t.title),
          el('span', { class: 'rec-option__desc' }, metaParts.join(' · ')),
          doneCount ? el('span', { class: 'rec-option__done' }, [el('span', { class: 'rec-check', 'aria-hidden': 'true' }), `${plural(doneCount, 'answer', 'answers')} kept`]) : null,
        ]),
      ]);
    }));
    app.refreshSendbars();
  }

  return {
    role: { onShow() {} },
    topic: { onShow: renderTopics },
  };
}
